export default __webpack_public_path__ + "e9ae0cc5a3fe44506a75b8e7c2b49939.png";